import styles from '@features/cms/components/categories/CategoryLabelBlock/CategoryLabelBlock.styles';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import { ICategoryLabelBlock } from '@features/pages/typescript';
type PropsType = {
  data: ICategoryLabelBlock;
  defaultBackground?: string;
  isFirst?: boolean;
};
const CategoryLabelBlock = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite,
  isFirst = false
}: PropsType) => {
  const {
    code,
    background,
    title,
    textColor,
    marginTop,
    marginBottom,
    variant
  } = data;
  const isNormal = variant === 'normal';
  return <div id={code} sx={styles.categoryLabelContainer} data-testid="CategoryLabelBlock">
      <div sx={styles.headingWrapper(background || defaultBackground, marginTop, marginBottom, !isNormal)} data-testid="CategoryLabelBlock-headingWrapper">
        <Heading h={isFirst ? 1 : 2} headingType={1} color={textColor || (!isNormal ? theme.rawColors.neutralWhite : theme.rawColors.darkGrey700)} mobile>
          {title}
        </Heading>
      </div>
    </div>;
};
export default CategoryLabelBlock;